const angular = require('angular');

angular.module('wowApp.common')
    .directive('wowEventRecorder', ['AnalyticsService', require('./event-recorder.directive')]);



// WEBPACK FOOTER //
// ./src/common/eventrecorder/index.js